import React from 'react';
import PropTypes from 'prop-types';
import { autocompleteLanguagesPath } from '../../../utilities/api_relative_paths';
import Autocomplete from './autocomplete';

const LanguagesAutocomplete = (props) => {
  const config = {
    placeholder: 'Select language',
    id: 'LanguagesAutocomplete',
    apiPath: autocompleteLanguagesPath,
    ...props,
  };

  return (
    <Autocomplete {...config}/>
  );
};

LanguagesAutocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default LanguagesAutocomplete;
